import ClayAvatar from './avatar';

export default ClayAvatar;
